import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const ServicesSection = () => {
  const { t } = useLanguage();
  const servicesList = t('servicesList');

  return (
    <section
      id="services"
      className="
        relative
        min-h-screen
        flex
        flex-col
        justify-start
        pt-24 md:pt-32
        pb-16 md:pb-20
        px-4 sm:px-6 md:px-8
        overflow-x-hidden
      "
    >
      <div className="max-w-4xl mx-auto w-full">
        {/* Main Title */}
        <div className="mb-10 md:mb-16 pb-4 md:pb-6 border-b border-[#2a2a2a]">
          <h2
            className="
              font-bold uppercase text-[#d8d8d8] opacity-50
              text-3xl sm:text-4xl md:text-6xl lg:text-7xl
              tracking-[0.12em] sm:tracking-[0.16em] md:tracking-[0.25em]
              break-words
            "
            style={{ fontFamily: 'var(--font-eurostile)' }}
          >
            {t('service')}

          </h2>
        </div>

        {/* Services List */}
        <div className="relative pl-5 sm:pl-6 md:pl-8 py-6 md:py-8 bg-gradient-to-r from-[#121416]/40 to-transparent border-l border-[#2a2a2a]">
          <div className="space-y-4 md:space-y-5">
            {servicesList.map((service, index) => (
              <div
                key={index}
                className="flex items-start text-[#d8d8d8]"
                style={{
                  fontFamily: 'var(--font-eurostile)',
                  fontSize: '18px',
                  lineHeight: '1.6',
                  fontWeight: '400',
                }}
              >
                <span className="text-[#5a6e54] font-bold mr-3 md:mr-4 flex-shrink-0">
                  •
                </span>
                <span className="flex-1">{service}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
